import {useEffect,useState,useRef} from 'react';
import { Dialog } from 'primereact/dialog';
import { useRouter } from 'next/router';
import axios from 'axios';


export default function Idletime(){
    const apiDirPath = "/api/_apibase_crud/";
    const endPointCookie = "/api/expired";

    const router = useRouter()

    const [urlPath,setUrlPath] = useState(null);
    const [showDialog,setShowDialog] = useState(false);
    const [hitungMundur,setHitungMundur] = useState(3);

    //fungsi useRef membuat referensi yang tidak berubah saat komponen re-render 
    const intervalRef = useRef(null);
    const urlPathRef = useRef(null);
    const showDialogRef = useRef(false);

    //url yang dikecualikan idleTime
    const exceptUrl = ['/login','/daftar'];
    
    useEffect(()=>{
        let idleTime;
        //fungsi start idle time
        const startIdleTimer = ()=>{
            if(!exceptUrl.includes(urlPathRef.current)){
                if(!exceptUrl.includes(router.asPath)){
                    idleTime = setTimeout(() => {
                        setShowDialog(true);
                        showDialogRef.current = true;
                    }, 3000000);
                }
            }
        }
        
        //fungsi reset idle time
        const resetIdleTimer = ()=>{
            clearTimeout(idleTime);
            if(!showDialogRef.current){
                startIdleTimer();
            }
           
        }
        //fungsi track mouse atau tap layar
        const setupIdleTime = ()=>{
            // untuk reset waktu
            document.addEventListener('mousemove', resetIdleTimer);
            document.addEventListener('keydown', resetIdleTimer);
            document.addEventListener('mousedown', resetIdleTimer);
            document.addEventListener('touchstart', resetIdleTimer);
            
            startIdleTimer();
        }
        setupIdleTime();
        //fungsi handle route.push() setelah redirect
        const handleRouteChange = (url) => {
            console.log('Current URL:', url);
            //set urlPathRef saat router.push() change complete
            urlPathRef.current = url;
          };
      
          router.events.on('routeChangeComplete', handleRouteChange);
      
          return () => {
            router.events.off('routeChangeComplete', handleRouteChange);
          };
    },[]);
    //fungsi untuk count down modal
    const countdown = ()=>{
        intervalRef.current = setInterval(() => {
            setHitungMundur((prevNilai)=> prevNilai-1);
        }, 1000);
        
    }

    useEffect(()=>{
        if(showDialog){
            countdown();
        }
    },[showDialog]);
    
    useEffect(()=>{
        if(hitungMundur < 1){
            clearInterval(intervalRef.current);
            setTimeout(()=>{
                router.push('/login');
                removeCookies();
                setShowDialog(false);
                showDialogRef.current = false;
            },500);
        }
    },[hitungMundur]);

    const removeCookies = async ()=>{
        const header = { 'Content-Type': 'application/json', 'X-ENDPOINT': endPointCookie,'X-IDUPDATE':''};
        const res =  await axios.post(apiDirPath,{},{ headers:header });
    }
    

    return (
        <>
            <Dialog visible={showDialog} style={{ width: '50vw' }} closable={false}>
                <strong>
                    <p className="m-0 text-center">
                        sesi anda telah habis
                    </p>
                </strong>
                <div className='m-0 text-center'>will redirect : {hitungMundur}</div>
            </Dialog>
        </>
    );

}